import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { useTranslator } from '@/hooks/useTranslator';
import { SsoCallbackView } from '../-components/SsoCallbackView';
import { useSsoCallback } from '../-hooks/useSsoCallback';

const searchSchema = z.object({
  sso_code: z.string().optional(),
  error: z.string().optional(),
});

/**
 * Where the backend's OAuth2 callback redirects the browser after an SSO
 * login (see `backend/.../oauth2-callback.ts`) — `?sso_code=...` on success,
 * `?error=sso_failed` on failure. Public: there is no session yet, since this
 * page is what creates one (see the root route's `beforeLoad`).
 */
export const Route = createFileRoute('/(login)/single-sign-on-callback/')({
  validateSearch: searchSchema,
  component: SsoCallbackPage,
});

function SsoCallbackPage() {
  const { getTranslation } = useTranslator({ page: 'login' });
  const { sso_code: ssoCode, error } = Route.useSearch();
  const { status } = useSsoCallback({ ssoCode, hasError: Boolean(error) });

  return (
    <SsoCallbackView
      status={status}
      labels={{
        loading: getTranslation('ssoCallback.loading'),
        failureTitle: getTranslation('ssoCallback.failureTitle'),
        failureBody: getTranslation('ssoCallback.failureBody'),
        statusPage: getTranslation('errors.statusPage'),
        backToLogin: getTranslation('ssoCallback.backToLogin'),
      }}
    />
  );
}
